// extracted by mini-css-extract-plugin
export default {"root":"app-react-components-CodeEditor-CodeEditor-module__root","codeEditor":"app-react-components-CodeEditor-CodeEditor-module__codeEditor"};